const FOCUSABLE_SELECTORS =
  'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
  'textarea:not([disabled]), button:not([disabled]), iframe, ' +
  '[tabindex]:not([tabindex="-1"])'

export const focusTrap = {
  mounted () {
    this.__focusTrapPreviousElement = document.activeElement

    this.$nextTick(() => {
      const focusable = this.$el.querySelectorAll(FOCUSABLE_SELECTORS)
      if (focusable.length) focusable[0].focus()
    })

    this.__focusTrapOnKeyDown = (event) => {
      if (event.key === 'Escape') {
        if (typeof this.closeModal === 'function') this.closeModal()
        return
      }

      if (event.key !== 'Tab') return

      const focusable = Array.from(this.$el.querySelectorAll(FOCUSABLE_SELECTORS))
      if (!focusable.length) return

      const first = focusable[0]
      const last = focusable[focusable.length - 1]

      if (event.shiftKey) {
        if (document.activeElement === first) {
          event.preventDefault()
          last.focus()
        }
      } else {
        if (document.activeElement === last) {
          event.preventDefault()
          first.focus()
        }
      }
    }

    document.addEventListener('keydown', this.__focusTrapOnKeyDown)
  },

  beforeDestroy () {
    document.removeEventListener('keydown', this.__focusTrapOnKeyDown)

    if (this.__focusTrapPreviousElement && this.__focusTrapPreviousElement.focus) {
      this.__focusTrapPreviousElement.focus()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/focusTrap.js